import React, { Component } from 'react'
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'
import * as Yup from 'yup'
import { apiProcess } from '../../api/api.js'
import { Button, Modal } from '../../elements'
import {
  trackReferralsEnterEmails,
  trackReferralsInviteSendSuccess,
  trackReferralsInviteSendAttempt,
} from '../../elements/tracking/referralsTracking.js'
import './emailInvitesInput.css'

class EmailInvitesInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      emailAddresses: [],
      emailError: false,
      emailSuccess: false,
      loading: false,
    }
  }

  handleEmailChange = (tags) => {
    this.setState({ emailError: false })

    this.setState({ emailError: false })

    let schema = Yup.array().of(Yup.string().email())

    schema
      .validate(tags)
      .then(
        function(valid) {
          this.setState({ emailAddresses: tags })
          trackReferralsEnterEmails()
        }.bind(this)
      )
      .catch(
        function(responseData) {
          this.setState({ emailError: true })
        }.bind(this)
      )
  }

  sendInvites = () => {
    //alert()

    if (this.state.emailAddresses.length === 0) {
      this.setState({ emailError: true })
      return false
    }
    this.setState({ emailError: false, sendError: false, loading: true })

    let apiURL = 'riders/referrals/send'

    let emailData = {
      emails: this.state.emailAddresses,
    }

    apiProcess(apiURL, emailData, 'referrals-send', 'Send Referral Emails')
      .then(
        function(responseData) {
          this.setState({
            emailAddresses: [],
            emailSuccess: true,
            loading: false,
          })
          trackReferralsInviteSendSuccess(this.state.emailAddresses.length)
        }.bind(this)
      )
      .catch(
        function(responseData) {
          this.setState({ sendError: true, loading: false })
          trackReferralsInviteSendAttempt(responseData)
        }.bind(this)
      )
  }

  close = () => this.setState({ open: false })

  render() {
    const { loading } = this.state

    const centerClass = this.props.center
      ? 'has-text-centered'
      : 'has-text-left'

    return (
      <React.Fragment>
        <TagsInput
          className={
            this.props.successScreen === true
              ? 'ref-email-invites-input'
              : 'ref-email-invites-input-black'
          }
          value={this.state.emailAddresses}
          placeholder="Add your friends email addresses"
          onChange={this.handleEmailChange}
          addKeys={[9, 13, 32]}
          addOnBlur={true}
          addOnPaste={true}
          inputProps={{
            placeholder: 'Add email addresses',
          }}
        />

        {this.state.emailError && (
          <div className={'has-text-danger ref-error ' + centerClass}>
            Please enter a valid email address.
          </div>
        )}
        {this.state.sendError && (
          <div className={'has-text-danger ref-error ' + centerClass}>
            Sorry, please try again.
          </div>
        )}

        <Modal
          size="tiny"
          show={this.state.emailSuccess}
          closeOnBlur={true}
          closeOnEsc={true}
          header={
            <span className="has-text-success">Your invites were sent!</span>
          }
          onClose={() => this.setState({ emailSuccess: false })}
        >
          <p>Feel free to send more invites to earn even more credit.</p>
          <Button
            color="primary"
            className="mt-4"
            onClick={() => this.setState({ emailSuccess: false })}
          >
            OK!
          </Button>
        </Modal>
        <div className={'ref-send-invites-button-wrap ' + centerClass}>
          <Button
            className="ref-send-invites-button has-text-weight-extra-bold"
            color="primary"
            size={'medium'}
            loading={loading}
            disabled={loading}
            onClick={() => this.sendInvites()}
          >
            Send Invites
          </Button>
        </div>
      </React.Fragment>
    )
  }
}

export default EmailInvitesInput

EmailInvitesInput.defaultProps = {
  center: true,
}
